
export const SidebarItemContent = ({ children }: { children?: any }) => (
  <div className="sidebar-teaser__decoration">{children}</div>
);

export default SidebarItemContent;
